import React from 'react';
import styles from '../utils/app.scss';
import Navigation from '../components/Navigation/Navigation';
import ProjectPreview from '../components/ProjectPreview/ProjectPreview';

const Index = props => {
  const projects = props.data.allMarkdownRemark.edges;
  const randomizedProjets = projects.slice(0, projects.length).sort(function(){
    return 0.5 - Math.random();
  });
  const aboutImg = props.data.imageSharp;
  return (
    <div>
      <Navigation projects={projects}/>
      <div className="index">
        <div className="splash-pg">
        {randomizedProjets.map(project => (
          <ProjectPreview project={project} key={project.node.fields.slug}/>
        ))}
        </div>
      </div>
    </div>
  );
};

export default Index;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
query allSlugs {
  allMarkdownRemark(sort:{fields: [frontmatter___title], order: ASC}) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          about
          description
          fonts {
            name
            type
            placeholder
          }
          designer
          fontName
          images {
            publicURL
          }
        }
      }
    }
  }
}
`;



// WEBPACK FOOTER //
// ./src/pages/index.jsx